export default __webpack_public_path__ + "static/Fig 7 - Access Track Detail-0a79e3bf8c603521109f695b2d35a9ba.pdf";